export default "__VITE_ASSET__ih2oHGvD__";